import { Button, Input, Label } from "@heathmont/moon-core-tw";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authLogin } from "../../services/auth.service";
import { apiBaseUrl } from "../../constants/environmentConstants";
interface FormValues {
  // Define your form fields here
  email: string;
  password: string;
}
const emailRegex = /^(?!.*\s)[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
// /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /.{8,32}$/;
const loginErrorMessage = "Incorrect email or password";
function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loginError, setLoginError] = useState(false);

  const [ssoError, setSsoError] = useState("");
  const navigate = useNavigate();

  const [ssoPending, setSsoPending] = useState(false);
  const [ssoPendingEmail, setSsoPendingEmail] = useState("");

  // Show SSO error or pending state if Azure redirected back with one
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const err = params.get("sso_error");
    const pending = params.get("sso_pending");
    const pendingEmail = params.get("sso_email");
    if (err) setSsoError(decodeURIComponent(err));
    if (pending === "true") {
      setSsoPending(true);
      setSsoPendingEmail(decodeURIComponent(pendingEmail || ""));
      window.history.replaceState({}, document.title, "/");
    }
  }, []);

  const handleSsoLogin = () => {
    const base = apiBaseUrl.replace(/\/$/, "");
    window.location.href = `${base}/employee/sso/login`;
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const emailValue = event.target.value;
    setEmail(emailValue);
    setLoginError(false);

    // if (formSubmitted && !emailValue?.match(emailRegex)) {
    //   setEmailError("Please enter a valid email address.");
    // } else {
    //   setEmailError("");
    // }
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const passwordValue = event.target.value;
    setPassword(passwordValue);
    setLoginError(false);

    // if (formSubmitted && !passwordValue?.match(passwordRegex)) {
    //   setPasswordError("Password should be at least 8 characters long.");
    // } else {
    //   setPasswordError("");
    // }
  };
  const onSubmit = async (data: FormValues) => {
    const res = await authLogin(data);

    if (res?.accessToken) {
      navigate("/");
      setEmail("");
      setPassword("");
      setEmailError("");
      setPasswordError("");
    } else {
      setLoginError(true);
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (emailError || passwordError) {
      return;
    }
    const loginCredentials: FormValues = { email: email, password: password };
    onSubmit(loginCredentials);
  };

  const handleBlur = (name: string, value: string) => {
    const regex = name === "email" ? emailRegex : passwordRegex;

    if (!value.match(regex)) {
      if (name === "email") {
        setEmailError("Please enter a valid email address.");
      } else if (name === "password") {
        setPasswordError(`Password should be at least 8 characters long.`);
      }
    }
  };

  if (ssoPending) {
    return (
      <div className="h-screen flex flex-col justify-between bg-form-pattern bg-no-repeat bg-center p-4 bg-cover">
        <div className="flex text-center flex-1 flex-col justify-center">
          <div className="mx-auto max-w-md w-full">
            <img className="mx-auto mb-8 h-14" src={"images/logo.svg"} alt="logo" />
            <div className="mx-auto py-9 px-10 bg-white rounded-xl shadow-3xl">
              <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Account Pending Setup</h3>
              <p className="text-sm text-[#8697A2] mb-1">Your Microsoft account has been recognised:</p>
              <p className="text-sm font-medium text-gray-700 mb-4">{ssoPendingEmail}</p>
              <p className="text-sm text-[#8697A2]">
                Your NurseFlow account has been created and is awaiting activation. Please contact your <strong>Branch Admin</strong> to assign your role and section.
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer 2xl:px-24 px-6 2xl:py-6 py-3">
          <div className="flex flex-wrap gap-4 md:flex-row flex-col-reverse md:justify-between justify-center items-center w-full">
            <p className="2xl:text-base text-sm text-[#8697A2] sm:text-left text-center flex-1">
            </p>

          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col justify-between bg-form-pattern bg-no-repeat bg-center p-4 bg-cover">
      <div className="flex text-center flex-1  flex-col justify-center ">
        <div className="mx-auto 2xl:max-w-1/2 max-w-md pt-12 w-full">
          <img
            className="mx-auto 2xl:mb-10 mb-10 h-14"
            src={"images/logo.svg"}
            alt="logo"
          />
          <h3 className="2xl:text-3xll text-2xl 2xl:mb-5 mb-3">
            Sign in to your account
          </h3>
          <p className="2xl:text-base text-sm text-[#8697A2] 2xl:mb-10 mb-4 2xl:max-w-auto max-w-sm mx-auto">
            Welcome to Nurseflow Management Portal. Enter your credentials to
            Sign In.
          </p>
          <form
            className="mx-auto 2xl:py-9 py-5 2xl:px-10 px-8 bg-white rounded-xl shadow-3xl"
            onSubmit={(event) => {
              handleSubmit(event);
            }}
          >
            <div className="mb-3">
              <Label
                htmlFor="email"
                className="text-start 2xl:text-base text-sm"
              >
                Email Address
              </Label>
              <Input
                type="text" //can be set as email too
                value={email}
                placeholder="Email Address"
                onChange={(event) => {
                  handleEmailChange(event);
                }}
                autoFocus
                onBlur={() => handleBlur("email", email)}
                onFocus={() => {
                  setEmailError("");
                  setLoginError(false);
                }}
              />
              {emailError && (
                <p className="text-dodoria text-left text-xs">{emailError}</p>
              )}
            </div>
            <div className="mb-4">
              <Label
                htmlFor="password"
                className="text-start 2xl:text-base text-sm"
              >
                Password
              </Label>
              <Input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(event) => {
                  handlePasswordChange(event);
                }}
                onBlur={() => handleBlur("password", password)}
                onFocus={() => {
                  setPasswordError("");
                  setLoginError(false);
                }}
              />
              {passwordError && (
                <p className="text-dodoria text-left text-xs">
                  {passwordError}
                </p>
              )}
              {loginError && (
                <p className="text-dodoria">{loginErrorMessage}</p>
              )}
            </div>

            <Button
              className="w-full  2xl:mb-5 mb-3 shadow-btnshadow "
              type="submit"
              variant="tertiary"
            >
              Login
            </Button>

            {/* Divider */}
            <div className="flex items-center gap-3 2xl:mb-5 mb-3">
              <hr className="flex-1 border-[#E5E7EB]" />
              <span className="text-xs text-[#8697A2]">or</span>
              <hr className="flex-1 border-[#E5E7EB]" />
            </div>

            {/* Sign in with Microsoft */}
            <button
              type="button"
              onClick={handleSsoLogin}
              className="w-full flex items-center justify-center gap-3 border border-[#E5E7EB] rounded-lg py-2 px-4 2xl:mb-5 mb-3 hover:bg-gray-50 transition-colors"
            >
              {/* Microsoft logo */}
              <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#00a4ef"/>
                <rect x="1" y="11" width="9" height="9" fill="#ffb900"/>
                <rect x="11" y="11" width="9" height="9" fill="#7fba00"/>
              </svg>
              <span className="2xl:text-base text-sm text-[#374151] font-medium">Sign in with Microsoft</span>
            </button>

            {ssoError && (
              <p className="text-dodoria text-sm mb-3">{ssoError}</p>
            )}

            <Link
              to="/forgot-password"
              className="2xl:text-base text-sm text-[#8697A2] cursor-pointer"
            >
              Forgot your password?
            </Link>
          </form>
        </div>
      </div>
      <hr />
      <div className="footer 2xl:px-24 px-6 2xl:py-6 py-3">
        <div className="flex flex-wrap gap-4 md:flex-row flex-col-reverse  md:justify-between justify-center items-center w-full">

        </div>
      </div>
    </div>
  );
}

export default LoginForm;

// {
//   /* <>
//       <div className="h-screen flex flex-col justify-between bg-form-pattern bg-no-repeat bg-center p-4 bg-cover">
//         <div className="flex text-center flex-1  flex-col justify-center ">
//           <div className="mx-auto max-w-1/2 pt-12">
//             <img
//               className="mx-auto mb-20"
//               src={"images/login-weblogo.png"}
//               alt="logo"
//             />
//             <h3 className="text-3xll mb-5">Sign in to your account</h3>
//             <p className="text-base mb-10">
//               Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
//               eiusmod tempor incididunt ut labore et dolore.
//             </p>
//             <Form
//               className="mx-auto py-9 px-10 bg-white rounded-xl shadow-3xl"
//               onKeyDown={(event) => {
//                 if (event.key === "Enter") {
//                   event.preventDefault();
//                   handleFormSubmit();
//                   // handleSubmit(handleFormSubmit)();
//                 }
//               }}
//               // onSubmit={handleSubmit(handleFormSubmit)}
//             >
//               <Form.Item className="mb-3">
//                 <Label htmlFor="email" className="text-start">
//                   Email Address
//                 </Label>
//                 <Input
//                   type="text"
//                   placeholder="Email"
//                   {...register("email", {
//                     pattern: {
//                       value:
//                         /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
//                       message: "Please enter a valid email address",
//                     },
//                     required: true,
//                   })}
//                   autoFocus={true}
//                   // onKeyDown={(event) => {
//                   //   if (event.key === "Enter") {
//                   //     event.preventDefault();
//                   //     handleFormSubmit();
//                   //   }
//                   // }}
//                   onChange={(e) => {
//                     clearErrors("email");
//                     setResponseError(false);
//                     const value = e.target.value;
//                     setCredentials({ ...credentials, email: value });
//                   }}
//                 />
//                 {errors.email && (
//                   <ErrorMessage
//                     errors={errors}
//                     name="email"
//                     render={({ message }: any) => {
//                       return message ? (
//                         <p style={{ color: "red" }}>{message}</p>
//                       ) : (
//                         <p>{}</p>
//                       );
//                     }}
//                   />
//                 )}
//               </Form.Item>
//               <Form.Item className="mb-4">
//                 <Label htmlFor="email" className="text-start">
//                   Password
//                 </Label>
//                 <Input
//                   type="password"
//                   placeholder="Password"
//                   {...register("password", {
//                     pattern: {
//                       value: /.{8,32}$/,
//                       message: "Password should be at least 8 characters long",
//                     },
//                     required: true,
//                   })}
//                   // onKeyDown={(event) => {
//                   //   if (event.key === "Enter") {
//                   //     event.preventDefault();
//                   //     handleFormSubmit();
//                   //   }
//                   // }}
//                   onChange={(e) => {
//                     clearErrors("password");
//                     setResponseError(false);
//                     const value = e.target.value;
//                     setCredentials({ ...credentials, password: value });
//                   }}
//                 />
//                 {errors.password && (
//                   <ErrorMessage
//                     errors={errors}
//                     name="password"
//                     render={({ message }: any) => {
//                       return message ? (
//                         <p style={{ color: "red" }}>{message}</p>
//                       ) : null;
//                     }}
//                   />
//                 )}

//                 {responseError ? (
//                   <p style={{ color: "red" }}>Invalid Email or Password</p>
//                 ) : null}
//               </Form.Item>
//               <Button
//                 className="w-full h-10 mb-5 shadow-btnshadow "
//                 type="submit"
//                 form="login"
//                 value="Submit"
//                 variant="tertiary"
//                 onClick={handleSubmit(onSubmit)}
//               >
//                 Log in
//               </Button>
//               <Link
//                 to="/forgot-password"
//                 className="text-base text-[#8697A2] cursor-pointer"
//               >
//                 Forgot your password?
//               </Link>
//             </Form>
//           </div>
//         </div>
//         <div className="footer px-24 py-6">
//           <div className="flex justify-between items-center">
//             <p className="text-base text-[#8697A2]">
//               Copyright ©
//               <span className="text-[#249CBA]">
//                 Nurseflow Management Portal |
//               </span>
//               All Rights Reserved
//             </p>
//
//           </div>
//         </div>
//       </div>
//     </> */
// }
